import { EnterpriseMember } from 'models/Enterprises';

export type AddMembersPeopleTable = Pick<
  EnterpriseMember,
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'title'
  | 'seniority'
  | 'businessUnitName'
  | 'location'
  | 'isOfficeManager'
> &
  Record<'phoneNumber' | 'linkedinAccount', string>;

export type AddMembersPeopleTableKeys = keyof AddMembersPeopleTable;

type AddMembersPeopleTableKeysArray = Array<AddMembersPeopleTableKeys>;

export const TABLE_COLUMNS: AddMembersPeopleTableKeysArray = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'title',
  'seniority',
  'businessUnitName',
  'location',
  'linkedinAccount',
  'isOfficeManager',
];

export const HEADER_OPTIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phoneNumber: 'phone',
  title: 'title',
  businessUnitName: 'businessUnit',
  seniority: 'seniority',
  location: 'location',
  linkedinAccount: 'linkedInProfile',
  isOfficeManager: 'officeManager',
};

export const REQUIRED_COLUMNS: Partial<AddMembersPeopleTableKeysArray> = [
  'firstName',
  'lastName',
  'email',
  'title',
  'businessUnitName',
  'seniority',
  'location',
];
